<template lang="pug" src="./commission-systems.pug"></template>

<script>
import {mapState, mapGetters} from 'vuex';

export default {
  filters: {
    booleanToText(value) {
      return value ? 'Да' : 'Нет';
    }
  },
  data: () => ({
    requestProcessing: false
  }),
  computed: {
    ...mapGetters(['userBrandId']),
    ...mapState({
      items: state => state.finances.commissionSystems.items,
      brands: state => state.data.brands,
      pagination: state => state.finances.commissionSystems.pagination,
      filters: state => state.finances.commissionSystems.filters
    }),
    headers() {
      const properties = [
        'id', 'name', 'period', 'brandId', 'createdAt', 'updatedAt',
        'drivers', 'startCalcDate', 'onlyForcedOrder', 'actions'
      ];

      return properties.map(it => ({
        text: this.$vuetify.lang.t(`$vuetify.pages.CommissionSystems.table.${it}`),
        value: it,
        sortable: false,
        align: 'center'
      }));
    },
    brandId: {
      get() {
        return this.filters.brandId;
      },
      set(val) {
        return this.$store.commit('finances/SET_COMMISSION_SYSTEMS_BRAND_ID', val);
      }
    },
    name: {
      get() {
        return this.filters.name;
      },
      set(val) {
        return this.$store.commit('finances/SET_COMMISSION_SYSTEMS_NAME', val);
      }
    }
  },
  created() {
    if (this.userBrandId) {
      this.brandId = this.userBrandId;
    }

    this.$store.dispatch('data/getBrands').then(() => {
      this.loadItems();
    });
  },
  methods: {
    loadItems(page = 1) {
      if (this.requestProcessing) return;

      this.requestProcessing = true;

      this.$store.dispatch('finances/getCommissionSystems', Object.assign({}, {
        ...this.filters,
        page
      })).then(() => {
        this.$nextTick(() => this.requestProcessing = false);
      });
    },
    onPageChange(page) {
      if (page !== this.pagination.page) {
        this.loadItems(page);
      }
    }
  }
};
</script>
